import { useEffect, useState } from 'react'

/** Returns `value` after it has stayed unchanged for `delayMs` milliseconds. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timerId = window.setTimeout(() => {
      setDebounced(value)
    }, delayMs)
    return () => {
      window.clearTimeout(timerId)
    }
  }, [value, delayMs])

  return debounced
}
